import fs from "fs";
import path from "path";
import { MetricsFile, SampleAnalysis, ModelInfo, MODEL_REGISTRY } from "./types";

const BENCHMARK_DIR = path.join(process.cwd(), "..", "benchmark_outputs");

export function getModels(): ModelInfo[] {
  const models: ModelInfo[] = [];
  for (const [modelId, displayName] of Object.entries(MODEL_REGISTRY)) {
    const modelDir = path.join(BENCHMARK_DIR, modelId);
    if (!fs.existsSync(modelDir)) {
      models.push({ id: modelId, displayName, checkpoints: [] });
      continue;
    }
    const checkpoints = fs.readdirSync(modelDir)
      .filter((d) => {
        const fullPath = path.join(modelDir, d);
        return fs.statSync(fullPath).isDirectory() &&
          fs.existsSync(path.join(fullPath, "metrics.json"));
      })
      .sort((a, b) => {
        const numA = parseInt(a.replace(/\D/g, "")) || 0;
        const numB = parseInt(b.replace(/\D/g, "")) || 0;
        return numA - numB;
      });
    models.push({ id: modelId, displayName, checkpoints });
  }
  return models;
}

export function getMetrics(modelId: string, checkpoint: string): MetricsFile | null {
  const filePath = path.join(BENCHMARK_DIR, modelId, checkpoint, "metrics.json");
  if (!fs.existsSync(filePath)) return null;
  const raw = fs.readFileSync(filePath, "utf-8");
  return JSON.parse(raw) as MetricsFile;
}

export function getSamples(modelId: string, checkpoint: string): SampleAnalysis[] | null {
  const filePath = path.join(BENCHMARK_DIR, modelId, checkpoint, "sample_analysis.json");
  if (!fs.existsSync(filePath)) return null;
  const raw = fs.readFileSync(filePath, "utf-8");
  return JSON.parse(raw) as SampleAnalysis[];
}

export function getAllMetricsForModel(modelId: string): Record<string, MetricsFile> {
  const result: Record<string, MetricsFile> = {};
  const model = getModels().find((m) => m.id === modelId);
  if (!model) return result;
  for (const ckpt of model.checkpoints) {
    const metrics = getMetrics(modelId, ckpt);
    if (metrics) result[ckpt] = metrics;
  }
  return result;
}
